import { SystemRoleName } from '@evimo/types/enums/system-role-name';
import { z } from 'zod';

export const OrgUserRole = {
  ORGANIZATION_MANAGER: SystemRoleName.ORGANIZATION_MANAGER,
  SUPERVISOR: SystemRoleName.SUPERVISOR,
  FIELD_TECHNICIAN: SystemRoleName.FIELD_TECHNICIAN,
} as const;

export type OrgUserRole = (typeof OrgUserRole)[keyof typeof OrgUserRole];

const orgUserRoleSchema = z.enum([
  OrgUserRole.ORGANIZATION_MANAGER,
  OrgUserRole.SUPERVISOR,
  OrgUserRole.FIELD_TECHNICIAN,
]);

export function parseOrgUserRole(role: string): OrgUserRole {
  return orgUserRoleSchema.parse(role);
}
